/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

/* =========================
   Shipping Protection Logic
   ========================= */

(function () {
  const VARIANT_ID = 53549578912028;
  const SECTION_ID = document
    .querySelector('cart-drawer')
    ?.getAttribute('data-section-id');

  function getCheckbox() {
    return document.getElementById('shipping-protection-checkbox');
  }

  function getCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function addProtection() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: VARIANT_ID, quantity: 1 })
    });
  }

  function removeProtection(cart) {
    const item = cart.items.find(i => i.variant_id === VARIANT_ID);
    if (!item) return Promise.resolve();

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    });
  }

  /* FORCE CART DRAWER RE-RENDER */
 function refreshCartDrawer() {
  if (!SECTION_ID) return;

  fetch(`/?sections=${SECTION_ID}`)
    .then(r => r.json())
    .then(sections => {
      const html = sections[SECTION_ID];
      if (!html) return;

      const temp = document.createElement('div');
      temp.innerHTML = html;

      const newDrawer = temp.querySelector('cart-drawer');
      const oldDrawer = document.querySelector('cart-drawer');
      if (!newDrawer || !oldDrawer) return;

    

      const safeSelectors = [
        '.cart-item-list',              // line items
        '.cart-drawer__footer',         // subtotal / checkout
        '.cart-discount-list',          // discounts
        '.subtotal',                    // subtotal value
        '.cart-drawer__title-count',    // cart item count (THIS FIX)
        '[data-merge="header-title"]'   // fallback for some themes
      ];

      safeSelectors.forEach(selector => {
        const newEl = newDrawer.querySelector(selector);
        const oldEl = oldDrawer.querySelector(selector);
        if (newEl && oldEl) {
          oldEl.innerHTML = newEl.innerHTML;
        }
      });

    
      if (window.theme && typeof theme.manuallyLoadImages === 'function') {
        theme.manuallyLoadImages(oldDrawer);
      }
    });
}




  function syncCheckbox() {
    const checkbox = getCheckbox();
    if (!checkbox) return;

    getCart().then(cart => {
      checkbox.checked = cart.items.some(
        item => item.variant_id === VARIANT_ID
      );
    });
  }

  /* EVENT DELEGATION */
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'shipping-protection-checkbox') return;

    e.target.disabled = true;

    if (e.target.checked) {
      addProtection()
        .then(refreshCartDrawer)
        .then(syncCheckbox)
        .finally(() => (e.target.disabled = false));
    } else {
      getCart()
        .then(cart => removeProtection(cart))
        .then(refreshCartDrawer)
        .then(syncCheckbox)
        .finally(() => (e.target.disabled = false));
    }
  });

  // Observe drawer rebuild
  const observer = new MutationObserver(syncCheckbox);
  observer.observe(document.body, { childList: true, subtree: true });

  syncCheckbox();
})();
